export default {
  section: {
    general: 'Všeobecné',
    data: 'Dáta',
    limits: 'Limity',
  },
};
